/* eslint-disable linebreak-style */
import en from 'vuetify/es5/locale/en';

export default {
  label: 'English',
  ...en,
};
